var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kinva-template',{attrs:{"identifier":_vm.identifier}})
}
var staticRenderFns = []

export { render, staticRenderFns }